export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5070.6bda13d4.jpg";